import { useTranslation } from "react-i18next";
import { Card, CardContent } from "@/components/ui/card";
import { Heart, Award, Users } from "lucide-react";

const values = [
  { icon: Heart, titleKey: "about.values.authenticity", descKey: "about.values.authenticityDesc" },
  { icon: Award, titleKey: "about.values.excellence", descKey: "about.values.excellenceDesc" },
  { icon: Users, titleKey: "about.values.community", descKey: "about.values.communityDesc" },
];

const AboutValues = ({ sectionRef }) => {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" data-testid="values-section" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="section-header">
          <span className="text-[#E07A5F] font-medium tracking-wider uppercase text-sm">
            {t("about.values.badge")}
          </span>
          <h2 className="mt-3">{t("about.values.title")}</h2>
          <p>{t("about.values.subtitle")}</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {values.map((value) => (
            <Card key={value.titleKey} className="bg-[#F4F1DE] border-0 card-hover" data-testid={`value-card-${value.titleKey}`}>
              <CardContent className="p-8 text-center">
                <div className="w-16 h-16 bg-[#E07A5F]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <value.icon className="w-8 h-8 text-[#E07A5F]" />
                </div>
                <h3 className="text-xl font-semibold text-[#3D405B] mb-3 font-['Playfair_Display']">{t(value.titleKey)}</h3>
                <p className="text-[#6B705C]">{t(value.descKey)}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutValues;
